module.exports = __webpack_public_path__ + "static/media/c4bannerModul3_small.21ad115a.jpg";